import { Container, Modal, Navbar } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { HiBars3BottomLeft } from 'react-icons/hi2';
import { RxCross1 } from 'react-icons/rx';
import { useEffect, useState } from 'react';
import navLinks from '../constants/navLinks.json';
import { AiOutlineLogin } from 'react-icons/ai';
import { BsSearch } from 'react-icons/bs';
import { FaUser } from 'react-icons/fa';
import Search from './common/Search';
import { useSelector } from 'react-redux';

const Header = () => {
    const { isAuthenticated } = useSelector((state) => state.user);
    const [showNav, setShowNav] = useState(false);
    const [showSearchModal, setShowSearchModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (showNav) {
            document.body.classList.add('stickDoc');
        } else {
            document.body.classList.remove('stickDoc');
        }
    }, [showNav]);

    const handleToggleSearch = () => setShowSearchModal(!showSearchModal);

    return (
        <>
            <div className={showNav ? 'showingNavbar' : ''}>
                <button className='bars' onClick={() => setShowNav(!showNav)}>
                    {!showNav ? <HiBars3BottomLeft /> : <RxCross1 />}
                </button>
                <Navbar className={`navbar`}>
                    <button className='closeNav' onClick={() => setShowNav(!showNav)}>
                        <RxCross1 />
                    </button>
                    <div className='mainNav'>
                        <Link className='logo' to={'/'}>
                            <img
                                src='/assets/images/logo.png'
                                alt=''
                                onClick={() => setShowNav(!showNav)}
                            />
                        </Link>
                        <ul className='main-menu'>
                            {navLinks.map((navItem) => (
                                <li key={navItem.link} onClick={() => setShowNav(!showNav)}>
                                    <Link to={navItem.link}>{navItem.name}</Link>
                                </li>
                            ))}
                        </ul>
                        <div className='d-flex justify-content-center userIcons'>
                            <button
                                onClick={() => {
                                    handleToggleSearch();
                                    setShowNav(!showNav);
                                }}
                            >
                                <BsSearch />
                            </button>
                            {isAuthenticated ? (
                                <button
                                    onClick={() => {
                                        navigate('/account');
                                        setShowNav(!showNav);
                                    }}
                                >
                                    <FaUser />
                                </button>
                            ) : (
                                <Link to={'/login'}>
                                    <span onClick={() => setShowNav(!showNav)}>
                                        <AiOutlineLogin />
                                    </span>
                                </Link>
                            )}
                        </div>
                    </div>
                </Navbar>
            </div>
            <Modal
                show={showSearchModal}
                onHide={handleToggleSearch}
                size='lg'
                centered
                className='searchContainer'
            >
                <Modal.Body>
                    <Search handleClose={handleToggleSearch} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Header;
